
// import React from "react";
// import { HeroSection } from "@/components/landing/hero/HeroSection";
// import { FeaturesSection } from "@/components/landing/FeaturesSection";
// import { CTASection } from "@/components/landing/CTASection";
// import { IntegrationsSection } from "@/components/landing/IntegrationsSection";
// import { StatsSection } from "@/components/landing/StatsSection";
import { HowItWorksSection } from "@/components/landing/HowItWorksSection";
// import { BenefitsSection } from "@/components/landing/BenefitsSection";
// import { ROICalculatorSection } from "@/components/landing/ROICalculatorSection";
// import { EarnSection } from "@/components/landing/EarnSection";
import { useIsMobile } from "@/hooks/use-mobile";
import { ExploreJobsSection } from "../ExploreJobs";
import { CompanyStatsSection } from "../CompanyStatsSection";
import StartJourneySection from "../StartJourneySection";
import ComapnyBenifitsSection from "../ComapnyBenifitsSection";

export const MainContent = () => {
  const isMobile = useIsMobile();
  
  // Optimize animations for mobile devices
  const getAnimationDelay = (index: number) => {
    if (isMobile) {
      // Reduce animation delays on mobile for better performance
      return index < 3 ? `${index * 75}ms` : '0ms';
    }
    return `${index * 100}ms`;
  };

  // Main sections to display on the landing page in order of priority
  const sections = [
    // { Component: HeroSection, index: 0, priority: "high" },
    // { Component: StatsSection, index: 1, priority: "high" },
    { Component: ExploreJobsSection, index: 1, priority: "high" },
    { Component: CompanyStatsSection, index: 1, priority: "high" },
    { Component: ComapnyBenifitsSection, index: 2, priority: "high" },
    // { Component: BenefitsSection, index: 2, priority: "high" },
    // The ROI Calculator is now integrated with BenefitsSection in terms of UI flow
    // { Component: ROICalculatorSection, index: 3, priority: "medium" },
    // { Component: EarnSection, index: 4, priority: "high" },
    // { Component: FeaturesSection, index: 5, priority: "high" },
    { Component: HowItWorksSection, index: 6, priority: "medium" },
    { Component: StartJourneySection, index: 6, priority: "medium" },
    // { Component: IntegrationsSection, index: 7, priority: "medium" },
    // { Component: CTASection, index: 8, priority: "high" }
  ];
  
  return (
    <div className="w-full max-w-[100vw] overflow-x-hidden">
      {sections.map(({ Component, index, priority }) => (
        <div 
          key={index} 
          className={`animate-fade-in ${isMobile && priority === "low" ? "print:hidden" : ""}`} 
          style={{ 
            animationDelay: getAnimationDelay(index),
            // Progressive loading optimization
            contain: isMobile ? 'content' : 'none'
          }}
        >
          <Component />
        </div>
      ))}
    </div>
  );
};
